// extracted by mini-css-extract-plugin
module.exports = {"dotsContainer":"UnsavedPages_dotsContainer__ArmKw","iframeContainer":"UnsavedPages_iframeContainer__Ue6_I","urlBarContainer":"UnsavedPages_urlBarContainer__POc79"};